// extracted by mini-css-extract-plugin
export default {"connectMessage":"InvitationGoogleConnect-module__connectMessage--lSh70","connectButton":"InvitationGoogleConnect-module__connectButton--iueKj"};